export default {
  state: {
    agentList: null,
    agentTotalCount: null,
    agentSingle: null
  },
  mutations: {
    setAgentList (state, payload) {
      state.agentList = payload
    },
    setAgentTotalCount (state, payload) {
      state.agentTotalCount = payload
    },
    setAgentSingle (state, payload) {
      state.agentSingle = payload
    }
  },
  actions: {
    getAgentList ({commit, dispatch}, data) {
      let date = '&date=' + data.date
      let branchId = data.branchId !== null ? '&branch_id=' + data.branchId : ''
      let saleGroupId = data.saleGroupId !== null ? '&sale_group_id=' + data.saleGroupId : ''
      let offset = data.offset !== null ? '&offset=' + data.offset : ''
      let limit = data.limit !== null ? '&limit=' + data.limit : ''
      const url = '/admin/agent/list?access_token=' + this.getters.accessToken + date + branchId + saleGroupId + offset + limit

      dispatch('apiGet', url)
        .then((data) => {
          commit('setAgentList', data.agent_list)
          commit('setAgentTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getAgentSingle ({commit, dispatch}, {id, date}) {
      const url = '/admin/agent/' + id + '/single?access_token=' + this.getters.accessToken + '&date=' + date
      dispatch('apiGet', url)
        .then((data) => {
          commit('setAgentSingle', data)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    agentList (state) {
      return state.agentList
    },
    agentTotalCount (state) {
      return state.agentTotalCount
    },
    agentSingle (state) {
      return state.agentSingle
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/agent.js